import { render } from "./Section4Payment.vue?vue&type=template&id=285233fe&ts=true"
import script from "./Section4Payment.vue?vue&type=script&lang=ts"
export * from "./Section4Payment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__